import React from 'react';
import styled from 'styled-components';
import buttonStyles from '../../../shared-styles/button-styles';

export default styled.button`
  ${props => buttonStyles(props)}
`;
